module.exports = {"explore":{"title":"Continuer l’exploration"}};